import React from "react";
import ReactDom from "react-dom";

import {observable, action, computed} from 'mobx';
import {observer} from 'mobx-react';

import {Decorator as editable} from 'simbox-editable';

import autoclass from 'autoclass-decorator';

import BaseViewStore from 'base-viewstore';
import BaseComponent from 'base-component';

import $ from 'jquery';

export class CollapsibleViewStore extends BaseViewStore {

    @observable open = false;
    @observable fixed = false;

    // validation is a derivation
    @computed get invalid(){
        const invalid = {};
        return invalid;
    }  
    @action.bound save() {}
}

@observer
export class CollapsibleComponent extends BaseComponent {

    static ViewStore = CollapsibleViewStore;

    render() {
      const {
          currentView,
          contentModel,
          form,
          lastCm,
          viewBreadcrumbs,
          insideEditor,
      } = this.props;

      const {
          titleContent,
          innerContent,
      } = contentModel; // this contentModel's properties

      const titleProps = {
          currentView: {contentModel: contentModel},
          options: {contentModel: titleContent},
          contentModel: titleContent,
          lastCm: lastCm,
          viewBreadcrumbs: viewBreadcrumbs,
          insideEditor: insideEditor,
          form: form,
      };
      const innerProps = {
          currentView: {contentModel: contentModel},
          options: {contentModel: innerContent},
          contentModel: innerContent,
          lastCm: lastCm,
          viewBreadcrumbs: viewBreadcrumbs,
          insideEditor: insideEditor,
          form: form,
      };

      let titleElement = titleContent && titleContent.Component ? React.createElement(titleContent.Component, titleProps) : <div>No Title Provided</div>;
      let innerElement = innerContent && innerContent.Component ? React.createElement(innerContent.Component, innerProps) : <div>No Content Provided</div>;

      let viewStore = this.viewStore;

      return (<div className={"accordion-container" + (viewStore.open ? " open" : "") + (viewStore.fixed ? " fixed" : "")}>
          <div className="accordion-fixed">
              <div className="metrics-bar">
                  {titleElement}
              </div>
          </div>
          <div className="accordion-title" onClick={() => {viewStore.open = !viewStore.open;}}>
              <div className="metrics-bar">
                  {titleElement}
                  <div className="metric-icon"></div>
              </div>
          </div>
          <div className="panel" id="accordion-1">
              {innerElement}
          </div>
      </div>)
  }

  componentDidMount() {
      
      let viewStore = this.viewStore;
      $('.activity-area').scroll(function () {
        let y = $('.activity-area').scrollTop();
          if (y > 120) {
              viewStore.fixed = true;
          } else {
              viewStore.fixed = false;
          }
      });
      $('.task-preview').scroll(function () {
          let y = $('.task-preview').scrollTop();
          if (y > 120) {
              viewStore.fixed = true;
          } else {
              viewStore.fixed = false;
          }
      });
  }
}

export default CollapsibleComponent; //need to export top level component as "default"



// WEBPACK FOOTER //
// ./app_modules/collapsible-activity/component.js